import {
  BasketballCoachLoggingCreateRequest,
  BasketballCoachLoggingSlice,
  BasketballTeamsSlice,
  ModalsSlice,
} from '@hefe/store';
import { t } from '@hefe/i18n';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import CustomForm from '../../core/components/form/custom-form';
import dayjs from 'dayjs';

export default function AddCoachLogForm() {
  const dispatch = useAppDispatch();
  const teams = useSelector(
    BasketballTeamsSlice.basketballTeamsSelectWithoutPendingSelector
  );

  useEffect(() => {
    fetchTeams();
  }, []);

  const fetchTeams = () => {
    dispatch(
      BasketballTeamsSlice.fetchBasketballTeamsSelect({
        cacheDuration: 5 * 60 * 1000,
      })
    )
      .unwrap()
      .catch(() => null)
      .finally(() => null);
  };

  const onSubmit = (values: any, resetForm: any) => {
    const request: BasketballCoachLoggingCreateRequest = {
      date: dayjs(values.date).format('YYYY-MM-DD'),
      team_id: values.team_id,
      note: values.note,
    };

    dispatch(ModalsSlice.modalsActions.setModalLoading(true));
    dispatch(BasketballCoachLoggingSlice.createBasketballCoachLogging(request))
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(ModalsSlice.modalsActions.closeModal());
      })
      .catch(() => null)
      .finally(() =>
        dispatch(ModalsSlice.modalsActions.setModalLoading(false))
      );
  };

  return (
    <CustomForm
      formId="add-coach-log"
      fields={[
        {
          name: 'date',
          type: 'date',
          label: t('date'),
          placeholder: t('select'),
          rules: [
            {
              required: true,
              type: 'date',
              message: t('form_errors.date'),
            },
          ],
        },
        {
          name: 'team_id',
          type: 'select',
          label: t('team'),
          placeholder: t('select'),
          rules: [
            {
              required: true,
              type: 'integer',
              message: t('form_errors.select_value'),
            },
          ],
          selectOptions: teams,
        },
        {
          name: 'note',
          type: 'text',
          label: t('note'),
          placeholder: t('note'),
          rules: [],
        },
      ]}
      onSubmit={onSubmit}
    />
  );
}
